import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import Script from 'next/script'
import styled from 'styled-components'
import { TrustpilotConfiguration } from './trustpilot-widget-config'

const WidgetWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  padding-top: 8px;
  background-color: white;
`

interface TrustpilotWidgetProps {
  brand: Brand
  locale?: string
}

export default function TrustpilotWidget({
  brand,
  locale = 'en-GB',
}: Readonly<TrustpilotWidgetProps>): JSX.Element {
  const config = TrustpilotConfiguration[brand]?.[locale]

  if (!config) {
    return null
  }

  return (
    <>
      <Script
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        strategy="afterInteractive"
      />
      <WidgetWrapper
        className="trustpilot-widget"
        data-locale={config.locale}
        data-template-id="5419b732fbfb950b10de65e5"
        data-businessunit-id={config.businessUnitId}
        data-style-height="24px"
        data-style-width="100%"
        data-theme="light"
        data-testid="trustpilot-widget"
      >
        <a href={config.href} target="_blank" rel="noopener">
          Trustpilot
        </a>
      </WidgetWrapper>
    </>
  )
}
